import { ApiService } from "../../../services/apiService";
import { routes } from "../../../services/paths";
import { handleRequestErrors } from "../../../shared/utils";


export const getAllElectionTypes = async () => {
  return await ApiService.request({
    url: `${routes.ALL_ELECTION_TYPE}`,
    http_method: "GET",
    headers: { "X-Signature": routes.apiKey },
  })
    .then((data: any) => {
      return data;
    })
    .catch((err: any) => {
      handleRequestErrors(err);
      return err;
    });
};

export const getAllElectionCandidates = async (electionType:string) => {
  return await ApiService.request({
    url: `${routes.ALL_ELECTION_CANDIDATES}?electionType=${electionType}`,
    http_method: "GET",
    headers: { "X-Signature": routes.apiKey },
  })
    .then((data: any) => {
      return data;
    })
    .catch((err: any) => {
      handleRequestErrors(err);
      return err;
    });
};

export const voteElectionCandidate = async (payload: any) => {
  return await ApiService.request({
    url: `${routes.VOTE_ELECTION_CANDIDATES}`,
    http_method: "POST",
    data: payload,
    headers: { "X-Signature": routes.apiKey },
  })
    .then((data: any) => {
      return data;
    })
    .catch((err: any) => {
      handleRequestErrors(err);
      return err;
    });
};


export const getHasVotedElection = async (
  electionTypes: string[],
  studentUniqueId: string
) => {
  const queryParams = new URLSearchParams();
  electionTypes.forEach((type) => queryParams.append("electionTypes", type));
  queryParams.append("studentUniqueId", studentUniqueId);

  return await ApiService.request({
    url: `${routes.HAS_VOTED_ELECTIONS}?${queryParams.toString()}`,
    http_method: "GET",
    headers: { "X-Signature": routes.apiKey },
  })
    .then((data: any) => data)
    .catch((err: any) => {
      handleRequestErrors(err);
      return err;
    });
};

export const getAllElectionStatus = async (electionType:string) => {
  return await ApiService.request({
    url: `${routes.SET_ELECTION_STATUS}?electionType=${electionType}`,
    http_method: "GET",
    headers: { "X-Signature": routes.apiKey },
  });
};

